import { useTranslation } from 'react-i18next';

import * as St from './ProductReplacementModal.styles';
import { RemovedProduct } from './utils';

export interface ProductReplacementModalProps {
  newMaterialName?: string;
  productsToReplace: RemovedProduct[];
  onCancel: () => void;
  onConfirm: () => void;
}

const ProductReplacementModal = ({
  productsToReplace,
  onCancel,
  onConfirm,
  newMaterialName,
}: ProductReplacementModalProps) => {
  const { t } = useTranslation();
  const modalLabel = {
    title: t('SCROLLABLE_AREA.MATERIAL.PRODUCT_REPLACEMENT_MODAL.TITLE'),
    description: t(
      'SCROLLABLE_AREA.MATERIAL.PRODUCT_REPLACEMENT_MODAL.DESCRIPTION',
      { newMaterial: newMaterialName }
    ),
    confirmationQuestion: t(
      'SCROLLABLE_AREA.MATERIAL.PRODUCT_REPLACEMENT_MODAL.CONFIRMATION_QUESTION'
    ),
    cancel: t('COMMON.NO'),
    confirm: t('COMMON.YES'),
  };

  return (
    <St.Container
      type="warning"
      title={modalLabel.title}
      isVisible={productsToReplace.length > 0}
      onClose={onCancel}
      content={
        <St.Content>
          <p>{modalLabel.description}</p>
          <St.Divider />
          <b>Removing:</b>
          <div>
            {productsToReplace.map((product, index) => (
              <St.ProductItem key={`${product.type}-${index}`}>
                <St.ProductImage src={product.imageUrl} alt={product.name} />
                <span>{product.name}</span>
              </St.ProductItem>
            ))}
          </div>
          <St.Divider />
          <span>{modalLabel.confirmationQuestion}</span>
        </St.Content>
      }
      footer={[
        <St.ModalButton key="cancel" onClick={onCancel}>
          {modalLabel.cancel}
        </St.ModalButton>,
        <St.ModalButton key="submit" data-type="submit" onClick={onConfirm}>
          {modalLabel.confirm}
        </St.ModalButton>,
      ]}
    />
  );
};

export default ProductReplacementModal;
